/**
 * 系统全局设置的存放目录
 */

//设置kcore
import './kcore-setting';
import appConfig from 'appConfig';
const titleEle = document.getElementById('indexTitle');
titleEle.innerHTML = appConfig.app.title || '实体数据管理系统';
